// import actionTypes, { baseURL } from "../actionTypes";

import actionTypes from "../actionTypes"
import shipmentFees from "../data/shipmentFees"



export const myCartList = (actionType = false) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.CART_LIST_LOADING, payload: true })
    dispatch({ type: actionTypes.CART_LIST_LOADING, payload: false })
    let cart = JSON.parse(sessionStorage.getItem('cart'))
    // let cartArray = [...getState().cart.cartList]
    let allProducts = [...getState().campaign.explore_products]
    // console.log('cart', cart);
    // console.log('allProducts', allProducts);
    let cartListFilter = allProducts.filter(aP => cart && cart.length > 0 && cart.includes(aP.id))

    // console.log('cartListFilter', cartListFilter);
    let cartList = cartListFilter && cartListFilter.length > 0 ? cartListFilter.map(item => {
      let unit_price = item.prices.find(pr => pr.currency === getState().login.currency)
        && item.prices.find(pr => pr.currency === getState().login.currency).price;
      let quantity = cart.filter(c => c === item.id).length
      return {
        id: item.id,
        quantity,
        name: item.name,
        unit_price,
        price: unit_price * quantity,
        media_url: item.media[0].url
      }
    }) : []
    console.log('actionType', actionType);
    if (actionType === "add") {
      // Measure when a product is added to a shopping cart
      window.dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'items': cartList && cartList.length > 0 ?
            cartList.map(item => {
              return {
            'item_name': item.name, // Name or ID is required.
            'item_id': item.id,
            'price': item.price,
            'item_unit_price':  item.unit_price,
            'quantity':item.quantity
            }}): []
        }
      });
      // Measure adding a product to a shopping cart by using an 'add' actionFieldObject
      // and a list of productFieldObjects.
      // window.dataLayer.push({
      //   'event': 'add_to_cart',
      //   // 'event': 'ecommerce-cart-add',
      //   'ecommerce': {
      //     'currencyCode': getState().login.currency,
      //     'add': {                                // 'add' actionFieldObject measures.
      //       'products':
      //         cartList && cartList.length > 0 ?
      //         cartList.map(item => {
      //           return {
      //           'name': item.name, // Name or ID is required.
      //           'id': item.id,
      //           'price': item.price,
      //           'unit_price':  item.unit_price,
      //           'quantity':item.quantity
      //           }
      //         })
      //         :[]
      //     }
      //   }
      // });
    }
    if (actionType === "remove") {
      // Measure the removal of a product from a shopping cart.
      // window.dataLayer.push({
      //   'event': 'remove_from_cart',
      //   'ecommerce': {
      //     'items':cartList&& cartList.length> 0 ?cartList.map(item => { return {
      //     'item_name': item.name, // Name or ID is required.
      //     'item_id': item.id,
      //     'price': item.price,
      //     'item_unit_price':  item.unit_price,
      //     'quantity':item.quantity
      //     }}): []
      //   }
      // });


      // Measure the removal of a product from a shopping cart.
      window.dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
          'remove': {   // 'remove' actionFieldObject measures.
            'products': //  removing a product to a shopping cart.
              cartList && cartList.length > 0 ?
                cartList.map(item => {
                  return {
                'name': item.name, // Name or ID is required.
                'id': item.id,
                'price': item.price,
                'unit_price':  item.unit_price,
                'quantity': item.quantity,
                // 'brand': 'Google',
                // 'category': 'Apparel',
                // 'variant': 'Gray',
              }}): []
          }
        }
      });
    }
    // To map the cart product id to the products from exlplore products
    dispatch({
      type: actionTypes.SET_CART_LIST,
      payload: { cartList: cartList }

    })
    dispatch(mycartTotal())
    dispatch(getTotalAmountDetail())
  }
}

export const addProductToMyCart = (product_id) => {
  return dispatch => {
    let cart = JSON.parse(sessionStorage.getItem('cart'))
    if (!cart) {
      cart = [product_id]
    } else cart.push(product_id)
    sessionStorage.setItem('cart', JSON.stringify(cart))
    dispatch(myCartList("add"))
  }
}

export const removeProductFromMyCart = (product_id) => {
  return dispatch => {
    let cart = JSON.parse(sessionStorage.getItem('cart'))
    if (cart) {
      cart = cart.filter(val => val !== product_id)
    }
    sessionStorage.setItem('cart', JSON.stringify(cart))
    console.log('updated cart', cart);
    dispatch(myCartList("remove"))
  }
}

export const reduceProductQuantity = (product_id) => {
  return dispatch => {
    let cart = JSON.parse(sessionStorage.getItem('cart'))
    if (cart) {
      cart.splice(cart.indexOf(product_id), 1)
    }
    sessionStorage.setItem('cart', JSON.stringify(cart))
    console.log('updated cart qty', cart);
    dispatch(myCartList("remove"))
  }
}

export const getTotalAmountDetail = (shipmentMethod = 0) => {
  return async (dispatch, getState) => {
    const shipmentFeesAmount = shipmentFees.find(shipment => shipment.currency === getState().login.currency)
    // await dispatch(myCartList())
    const total = getState().cart.totalCartAmount + shipmentFeesAmount.fees;

    return dispatch({
      type: actionTypes.SET_TOTAL_PRICE_AMOUNT,
      payload: total
    })
  }
}

export const mycartTotal = () => {
  return (dispatch, getState) => {
    let priceTotal = [0];
    priceTotal = getState().cart.cartList && getState().cart.cartList
      .map(pr => pr.price)

    priceTotal = priceTotal && priceTotal.reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)

    return dispatch({
      type: actionTypes.SET_TOTAL_CART_PRICE_AMOUNT,
      payload: priceTotal
    })
  }
}

export const getShippingFees = () => {
  return (dispatch, getState) => {
    let feeDetail = shipmentFees.find(shipment => shipment.currency === getState().login.currency)
    return dispatch({
      type: actionTypes.SET_SHIPMENT_FEE_DETAIL,
      payload: feeDetail
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/cart.action.js